import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface VerifyOtpState {
    email: string;
    isLoading: boolean;
    isVerified: boolean;
    verifyError: string;
    otp: string;
}

const initialState: VerifyOtpState = {
    email: "",
    isLoading: false,
    isVerified: false,
    verifyError: "",
    otp: "",
};

const verifyOtpSlice = createSlice({
    name: "verifyOtp",
    initialState,
    reducers: {
        sendOtpSuccess: (state: VerifyOtpState, action: PayloadAction<{ email: string }>) => {
            state.email = action.payload.email; // Save email when OTP is sent
          },
        verifyOtpStart(state: VerifyOtpState, action: PayloadAction<string>) {
            state.isLoading = true;
            state.verifyError = "";
            state.isVerified = false;
            state.otp = action.payload;
        },
        verifyOtpSuccess(state: VerifyOtpState) {
            state.isLoading = false;
            state.isVerified = true;
        },
        verifyOtpError(state: VerifyOtpState, action: PayloadAction<string>) {
            state.isLoading = false;
            state.verifyError = action.payload;
            state.isVerified = false;
        },
    },
});

export const { verifyOtpStart, verifyOtpSuccess, verifyOtpError } = verifyOtpSlice.actions;
export default verifyOtpSlice.reducer;
